import {
  Component, OnDestroy, OnInit,
  ViewChild
} from '@angular/core';
import {NgForm} from '@angular/forms';
import {UserAuthentication} from '../../../service/restAngular/user-authentication';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  providers: [UserAuthentication],
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnDestroy, OnInit {
  passwordModel = '';
  confrimPassword = '';
  private token: string;
  tokenError;
  @ViewChild('resetForm') resetForm: NgForm;

  constructor(private userAuthentication: UserAuthentication,
              private route: ActivatedRoute,
              private router: Router) {
      document.body.classList.add('login');
  }
  ngOnInit() {
    this.route.params.subscribe((params: any) => {
      this.token = params.token;
    });
  }
  ngOnDestroy() {
    document.body.classList.remove('login');
  }

  reset() {
    if (this.resetForm.valid && this.passwordModel === this.confrimPassword) {
      const data = {
        password: this.passwordModel,
        repeat_password: this.passwordModel
      };
      this.userAuthentication.changePassword(data, this.token).subscribe(() => {
        this.router.navigateByUrl('/');
      },
        ()=>{
          this.tokenError = "This link has already been used.";
        })
    }
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/login-signup/reset-password/reset-password.component.ts